import React from 'react';
import Image from 'next/image';
import Error from '@mui/icons-material/Error';
import ComparisonBox from './ComparisonBox';
import CityRankTable, { CityRankRowType } from './CityRankTable';
import {
  COMPETITIVE_SCORE_INTRO,
  TAB_CITY_COMPARISON,
  TAB_MAP,
} from '@/constants/job-title';
import { JobTitleContext } from '@/context/create-context';
import cityIcon from '@/assets/job-title/city.svg';

const CityComparison = () => {
  const {
    jobTitle: {
      id,
      city_name: cityName = '',
      salary_details: { competitive_rank, avg, competitive_rate, avg_median },
      location,
      job_open_details: { current_count },
    },
    displayName,
  } = React.useContext(JobTitleContext);

  const jobTitleName = cityName
    ? displayName.replace(cityName, '')
    : displayName;

  return (
    <>
      <div className="relative">
        <div className="font-semibold text-2xl flex items-center mb-9 tablet:mb-10">
          <Image
            src={cityIcon}
            alt="city comparison icon"
            width={24}
            height={24}
          />
          <h2 className="ml-2 opacity-85">{TAB_MAP[TAB_CITY_COMPARISON]}</h2>
        </div>
        <ComparisonBox />
        <CityRankTable
          title={`${jobTitleName}工作城市排名`}
          displayName={jobTitleName}
          pinned={
            cityName
              ? ({
                  id: competitive_rank,
                  name: location?.name,
                  pinyin: location?.pinyin,
                  jobTitleId: id,
                  jobTitleName,
                  count: current_count,
                  avg,
                  avgMedian: avg_median,
                  housePrice: location?.house_price,
                  competitive: competitive_rate * 100,
                  isPinned: true,
                } as CityRankRowType)
              : undefined
          }
        />
        <p className="absolute -bottom-8 left-0 flex items-center text-xs leading-5">
          <Error className="!text-base !mr-1 !text-black/60" />
          房价数据来源：城市房网
        </p>
      </div>
      <div className="my-12 py-2 pl-3 pr-5 rounded-md bg-white tablet:hidden shadow-[0px_8px_15px_rgba(0,0,0,0.15)]">
        <p className="text-base leading-6.5">
          <strong>谈职薪资竞争力指数：</strong>
          <br />
          指用本职位的薪资在此城市生活的舒适度，指数越高代表该职位在此城市的竞争力越高
        </p>
        <p className="mt-3 text-sm leading-5.5">
          我们的计算方式：
          <br />
          {COMPETITIVE_SCORE_INTRO}
        </p>
      </div>
    </>
  );
};

export default CityComparison;
